/* Snyvia: keep the "More" menu card centred under the "More" button (see snyvia-more-menu.css). */
(() => {
  const place = () => {
    const host = document.querySelector('.overflow-menu');
    const part = host && host.shadowRoot && host.shadowRoot.querySelector('[part~="overflow"]');
    const more = host && host.querySelector('[slot="more"]');
    if (!part || !more) return;
    const cb = (part.offsetParent || document.documentElement).getBoundingClientRect();
    const m = more.getBoundingClientRect();
    host.style.setProperty('--snyvia-more-x', `${Math.round(m.left + m.width / 2 - cb.left)}px`);
    host.style.setProperty('--snyvia-more-y', `${Math.round(m.bottom - cb.top)}px`);

    // Sub-cards (e.g. Ethnic Collections) open to the right unless that would run off the screen.
    const cardRight = m.left + m.width / 2 + part.offsetWidth / 2;
    const subWidth = Math.max(0, ...[...host.querySelectorAll('[slot="overflow"] .menu-list__submenu')].map((s) => s.offsetWidth));
    host.dataset.snyviaFlyout = cardRight + subWidth + 8 > document.documentElement.clientWidth ? 'left' : 'right';
  };
  document.addEventListener('pointerover', (e) => {
    if (e.target instanceof Element && e.target.closest('[slot="more"]')) place();
  });
  document.addEventListener('focusin', (e) => {
    if (e.target instanceof Element && e.target.closest('[slot="more"]')) place();
  });
  window.addEventListener('resize', place);
  window.addEventListener('scroll', place, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();
})();
